// extracted by mini-css-extract-plugin
export default {"secondaryBannerLightBlock":"SecondaryBannerLightBlock_secondaryBannerLightBlock__fzLmM","secondaryBanner":"SecondaryBannerLightBlock_secondaryBanner__DPEqj"};